































































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { PageTitle } from '../../core/components';
import SectionTitle from '../../core/components/SectionTitle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue';
import ModalUserPreferences from '../components/ModalUserPreferences.vue'
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { ColorsList } from '../../core/utils';
import { UserList } from '../models/Users';
import { UserService } from '../../core/api/UserService';
import { AuthStoreHelper, NotificationStoreHelper } from '../../core/mixins';

@Component({
    components: {
        PageTitle,
        SectionTitle,
        SimpleTable,
        ModalUserPreferences,
        DeleteConfirmation,
        Input
    }
})
export default class UsersPage extends Mixins(
    NotificationStoreHelper,
    AuthStoreHelper
) {
    goldColor: string = ColorsList.gold;
    userInfo: UserList | null = null;
    sortBy: string[] = ['username'];
    sortDesc: boolean[] = [false];
    loadingDelete: boolean = false;
    usersList: Array<UserList> = [];
    search: string = '';
    openDeleteModal: boolean = false;
    deleteConsequences:Array<string> = [];
    deleteConfirmationBody: string = '';
    deleteTitle: string = '';
    headers: Array<object> = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'username',
        },
        {
            text: 'E-mail',
            align: 'center',
            value: 'email'
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions'
        }
    ];
    pendingUsers: boolean = false;
    visibleChangePassword: boolean = false;
    userIdToDelete: number = -1;
    hasToLogoutUser: boolean = false;

    deleteUserClicked(user: UserList): void {
        let deleteConsequences = ['El usuario no podrá acceder a la plataforma'];
        let deleteTitle = `Eliminar Usuario ${user.username}`;
        let deleteConfirmBody = '¿Está seguro que desea eliminar el usuario <b>' + user.username + '</b>?';
        let currentAuth = this.$_getAuth;
        let hasToLogout = false;
        if(currentAuth && currentAuth.id == user.id){
            deleteTitle = 'Eliminar usuario actual';
            deleteConsequences = [
                'Ya no podrás acceder a la plataforma',
                'Serás desconectado automáticamente'
            ]
            deleteConfirmBody = '¿Está seguro que desea eliminar su usuario actual <b>' + user.username + '</b>?';
            hasToLogout = true;
        }
        this.hasToLogoutUser = hasToLogout;
        this.deleteConsequences = deleteConsequences;
        this.deleteTitle = deleteTitle;
        this.userIdToDelete = user.id;
        this.deleteConfirmationBody = deleteConfirmBody;
        this.setOpenConfirmation(true);
    }

    handleConfirmation(confirmation: boolean): void {
        let self = this;
        if (confirmation) {
            this.setOpenConfirmation(false);
            this.loadingDelete = true;
            UserService.deleteUser(
                this.userIdToDelete
            ).then((res) => {
                this.loadingDelete = false;
                this.setOpenConfirmation(false);
                this.getUsers();
                this.$_successPatchRecipients(res.data.message);
                if(self.hasToLogoutUser){
                    self.$_closeSession();
                }
            }).catch((err) => {
                this.loadingDelete = false;
                this.$_catchLoadingDialog({
                    response: err.response.data || {},
                    alternative_msg: 'No se pudo eliminar el usuario'
                });
            }
            )
        } else {
            this.setOpenConfirmation(false);
        }
    }

    setOpenConfirmation(value: boolean): void {
        this.openDeleteModal = value;
    }



    sendNewPasswordToMail(user: UserList){
        this.$set(user, 'loading', true);
        UserService.sendNewPasswordToEmail(user.id, user.email)
        .then((res) => {
            this.$set(user, 'loading', false);
             this.$_successPatchRecipients(res.message);
        }).catch((err) => {
            this.$set(user, 'loading', false);
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudo enviar la nueva contraseña al correo'
            });
        })
    }

    updateUserInUsersList(id: number, newEmail: string){
        let indexUserInList = this.usersList.findIndex(user => user.id == id);
        if(indexUserInList !== -1){
            this.$set(this.usersList[indexUserInList], 'email', newEmail);
        }
    }

    updateSearchValue(value){
        this.search = value
    }

    created(){
        this.getUsers();
    }

    getUsers(){
        this.pendingUsers = true;
        this.usersList = [];
        UserService.getUsersList()
            .then((res) => {
             this.pendingUsers = false;
                this.usersList = res;

            }).catch((e) => {
                this.pendingUsers = false;
                this.$_catchLoadingDialog({
                    response: e.response.data || {},
                    alternative_msg: 'Falló el listado de usuarios'
                });
            })
    }

    closeUserPreferences(){
        this.userInfo = null;
        this.visibleModalChangePassword(false)
    }

    showChangePasswordModal(user: UserList){
        this.userInfo = user;
        this.visibleModalChangePassword(true);
    }

    visibleModalChangePassword(value){
        this.visibleChangePassword = value;
    }
    
    volverAConfiguracion() {
        this.$router.push(NAME_ROUTES.SETTINGS.path);
    }
}
